// extracted by mini-css-extract-plugin
module.exports = {"galleryCarouselWrapper":"GalleryCarouselWrapper_galleryCarouselWrapper__3gIma"};